import { Checkbox, Dropdown, DropdownMenuItemType, Icon, Label, SearchBox, Stack } from "@fluentui/react";
import React, { useEffect, useState,useRef} from "react";
import { mergeStyles } from "react-select";


const CustomMultiSelectDropdown = ({
  options,
  label,
  placeholder,
  styles,
  dropdownRef,
  selectedKeys,
  setSelectedKeys,
  customClassName,
}) => {
  const [searchText, setSearchText] = useState("");
  const [filteredOptions, setFilteredOptions] = useState();

  const onSearchChange = (event, newValue) => {
    setSearchText(newValue || "");
  };

  const onCheckboxChange = (event, option) => {
    const newSelectedKeys = [...selectedKeys];
    if (option.selected) {
      newSelectedKeys.push(option.key);
    } else {
      const index = newSelectedKeys.indexOf(option.key);
      if (index > -1) {
        newSelectedKeys.splice(index, 1);
      }
    }
    setSelectedKeys(newSelectedKeys);
  };

  useEffect(() => {
    console.log("filtered option values", filteredOptions);
    if (options.length > 0) {
      const tempFilteredOptions = options.filter((option) => {
        return option.text.toLowerCase().includes(searchText.toLowerCase());
      });
      setFilteredOptions(tempFilteredOptions);
    }
  }, [options, searchText]);

  useEffect(() => {
    //console.log(selectedKeys);
  }, [selectedKeys]);

  const renderOption = (option) => (
    <div key={option.key} className={mergeStyles({ padding: "4px 8px" })}>
      <Checkbox
        label={option.text}
        checked={selectedKeys.includes(option.key)}
        onChange={(e, checked) =>
          onCheckboxChange(e, { ...option, selected: checked })
        }
      />
    </div>
  );

  return (
    <div style={{ width: "100%" }}>
      <Label className={customClassName}>{label}</Label>
      <Dropdown
        placeholder={
          selectedKeys?.length === 0
            ? placeholder
            : `Selected ${selectedKeys?.length} of ${options?.length}`
        }
        selectedKey={null}
        styles={styles}
        onRenderTitle={() => console.log("hi title is getting rendered")}
        onRenderContainer={({ calloutProps }) => (
          <div className="custom-multiselect">
            <SearchBox placeholder="Search options" onChange={onSearchChange} />
            <div style={{ maxHeight: 150, overflowY: "auto" }}>
              {filteredOptions.length > 0 ? (
                filteredOptions.map(renderOption)
              ) : (
                <div>No records found</div>
              )}
            </div>
          </div>
        )}
        onRenderCaretDown={() => <Icon iconName="ChevronDown" />}
        onDismiss={() => setSearchText("")}
        componentRef={dropdownRef}
        className={customClassName}
      />
    </div>
  );
};

const CustomMultiSelect = ({
  dropdownRef,
  options,
  placeholder,
  selectedKeys,
  setSelectedKeys,
  customClassName,
  label
}) => {
  const dropdownStyles = {
    dropdown: {
      width: "100%",
    },
    dropdownItemSelected: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    dropdownItemsWrapper: {
      maxHeight: "200px",
    },
    dropdownItem: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
      color: "white",
    },
  };

  return (
    <Stack tokens={{ childrenGap: 20 }}>
      <CustomMultiSelectDropdown
        placeholder={placeholder}
        label={label}
        options={options}
        styles={dropdownStyles}
        dropdownRef={dropdownRef}
        selectedKeys={selectedKeys}
        setSelectedKeys={setSelectedKeys}
        customClassName={customClassName}
      />
    </Stack>
  );
};
export default CustomMultiSelect;